export default __webpack_public_path__ + "images/FD.bee356c.png";